import { Shield, ArrowRight, Users, TrendingUp, Heart, Calculator } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import PublicShell from '@/components/layouts/PublicShell';

const FinanzberatungFrauenPage = () => {
  return (
    <PublicShell>
          {/* Hero Section - Exact Height */}
          <div className="relative" style={{height: '70vh'}}>
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{backgroundImage: 'url(/images/sv-skyline-financial.jpg)'}}
            ></div>
            <div className="absolute inset-0 bg-gradient-to-r from-slate-900/75 via-slate-800/60 to-transparent"></div>
            
            <div className="relative z-10 h-full flex items-center px-16">
              <div className="max-w-3xl">
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-light text-white mb-8 leading-tight font-serif">
              Finanzberatung für Frauen
            </h1>
                
                <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-10 max-w-3xl">
                  Mit Fokus auf besondere Lebenssituationen - Ihre finanzielle Unabhängigkeit im Mittelpunkt
                </p>
                
          </div>
        </div>
      </div>

          {/* Green Section */}
          <div className="bg-primary-800">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left Side - Text (3 columns) */}
              <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
                <div className="max-w-2xl">
                  <div className="w-16 h-16 mb-8">
                    <Heart className="w-16 h-16 text-white" />
                  </div>
                  
                  <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight font-serif">
                    Warum spezielle Finanzberatung für <em className="italic">Frauen?</em>
                  </h2>
                  
                  <p className="text-xl text-primary-100 leading-relaxed">
                    Frauen haben oft andere Lebensverläufe und finanzielle Herausforderungen. 
                    Wir berücksichtigen diese besonderen Umstände in unserer Beratung.
                  </p>
                </div>
              </div>

              {/* Right Side - Image (2 columns) */}
              <div className="lg:col-span-2 relative min-h-96">
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{backgroundImage: 'url(/images/sv-office-building.jpg)'}}
                ></div>
              </div>
            </div>
          </div>

          {/* Three White Cards Section - Challenges */}
          <div className="relative -mt-16 z-20">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
              {/* Single Large White Box */}
              <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
                <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
                  {/* Card 1 - Familienphasen */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Familienphasen berücksichtigen</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Elternzeit, Teilzeit, Karrierepausen - wir planen Ihre Finanzen mit Blick auf alle Lebensphasen. 
                      Unsere Strategien sind flexibel und passen sich Ihren Lebensumständen an.
                    </p>
                  </div>

                  {/* Card 2 - Gender Pay Gap */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Gender Pay Gap ausgleichen</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Strategien entwickeln, um trotz Einkommensunterschieden langfristig Vermögen aufzubauen. 
                      Wir zeigen Ihnen, wie Sie mit intelligenten Sparplänen Ihre finanzielle Unabhängigkeit erreichen.
                    </p>
                  </div>

                  {/* Card 3 - Absicherung */}
                  <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 py-12 text-left">
                    <h3 className="text-xl font-bold text-slate-800 mb-6 leading-tight">Absicherung optimieren</h3>
                    <p className="text-[16px] text-slate-600 leading-relaxed">
                      Besondere Risiken wie Berufsunfähigkeit oder Altersarmut gezielt absichern. 
                      Wir entwickeln umfassende Schutzkonzepte, die auf Ihre Lebenssituation abgestimmt sind.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Purple Section - Services */}
          <div className="bg-primary-900 py-20">
            <div className="grid grid-cols-1 lg:grid-cols-5">
              {/* Left Side - Text (3 columns) */}
              <div className="lg:col-span-3 p-12 lg:p-20 flex items-center">
                <div className="max-w-2xl">
                  <div className="w-16 h-16 mb-8">
                    <Users className="w-16 h-16 text-white" />
                  </div>
                  
                  <h2 className="text-4xl md:text-5xl font-light text-gold-400 mb-8 leading-tight font-serif">
                    Unsere <em className="italic">Beratungsschwerpunkte</em>
                  </h2>
                  
                  <p className="text-xl text-primary-100 leading-relaxed">
                    Von der Altersvorsorge bis zur Absicherung - wir bieten umfassende Finanzberatung, 
                    die speziell auf die Bedürfnisse von Frauen zugeschnitten ist.
                  </p>
                </div>
              </div>

              {/* Right Side - Image (2 columns) */}
              <div className="lg:col-span-2 relative min-h-96">
                <div 
                  className="absolute inset-0 bg-cover bg-center"
                  style={{backgroundImage: 'url(/images/sv-skyline-day.jpg)'}}
                ></div>
              </div>
            </div>
          </div>

          {/* Four White Cards Section - Services */}
          <div className="relative -mt-16 z-20">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24">
              {/* Single Large White Box */}
              <div className="bg-white rounded-none shadow-[0_8px_40px_rgba(16,24,40,0.08)] w-full mb-12">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-y lg:divide-y-0 lg:divide-x divide-gray-200">
                  {/* Card 1 - Altersvorsorge */}
                  <div className="px-6 sm:px-8 md:px-10 lg:px-8 xl:px-12 py-12 text-left">
                    <div className="w-12 h-12 bg-gold-500 rounded-none flex items-center justify-center mb-6">
                      <Calculator className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-800 mb-4 leading-tight">Altersvorsorge für Frauen</h3>
                    <p className="text-[14px] text-slate-600 leading-relaxed mb-3">
                      Frauen leben länger und haben oft geringere Rentenansprüche.
                      Wir entwickeln maßgeschneiderte Vorsorgestrategien.
                    </p>
                    <div className="text-[12px] text-slate-600 space-y-1">
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Riester-Rente mit Kinderzulagen optimal nutzen</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Private Rentenversicherung flexibel gestalten</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>ETF-Sparpläne für langfristigen Vermögensaufbau</span></div>
                    </div>
                  </div>

                  {/* Card 2 - Familie & Beruf */}
                  <div className="px-6 sm:px-8 md:px-10 lg:px-8 xl:px-12 py-12 text-left">
                    <div className="w-12 h-12 bg-gold-500 rounded-none flex items-center justify-center mb-6">
                      <Users className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-800 mb-4 leading-tight">Familie & Beruf vereinbaren</h3>
                    <p className="text-[14px] text-slate-600 leading-relaxed mb-3">
                      Finanzplanung für verschiedene Lebensphasen - von der Karriere bis zur Familienzeit.
                    </p>
                    <div className="text-[12px] text-slate-600 space-y-1">
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Elterngeld optimal nutzen</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Teilzeit finanziell abfedern</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Wiedereinstieg nach Familienpause planen</span></div>
                    </div>
                  </div>

                  {/* Card 3 - Vermögensaufbau */}
                  <div className="px-6 sm:px-8 md:px-10 lg:px-8 xl:px-12 py-12 text-left">
                    <div className="w-12 h-12 bg-primary-500 rounded-none flex items-center justify-center mb-6">
                      <TrendingUp className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-800 mb-4 leading-tight">Intelligenter Vermögensaufbau</h3>
                    <p className="text-[14px] text-slate-600 leading-relaxed mb-3">
                      Auch mit kleineren Beträgen systematisch Vermögen aufbauen und finanzielle Unabhängigkeit erreichen.
                    </p>
                    <div className="text-[12px] text-slate-600 space-y-1">
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Sparpläne ab 25€ monatlich</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Nachhaltige Geldanlagen</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Risiko-angepasste Strategien</span></div>
                    </div>
                  </div>

                  {/* Card 4 - Absicherung */}
                  <div className="px-6 sm:px-8 md:px-10 lg:px-8 xl:px-12 py-12 text-left">
                    <div className="w-12 h-12 bg-red-500 rounded-none flex items-center justify-center mb-6">
                      <Shield className="w-6 h-6 text-white" />
                    </div>
                    <h3 className="text-lg font-bold text-slate-800 mb-4 leading-tight">Umfassende Absicherung</h3>
                    <p className="text-[14px] text-slate-600 leading-relaxed mb-3">
                      Schutz vor existenziellen Risiken - angepasst an die besonderen Bedürfnisse von Frauen.
                    </p>
                    <div className="text-[12px] text-slate-600 space-y-1">
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Berufsunfähigkeitsversicherung</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Risikolebensversicherung für Familien</span></div>
                      <div className="flex gap-1"><span className="shrink-0">•</span><span>Krankentagegeld bei Selbstständigkeit</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section - Pink */}
          <div className="bg-pink-600 py-16">
            <div className="max-w-[1720px] mx-auto px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 text-center">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                  Ihre finanzielle Unabhängigkeit beginnt heute
                </h2>
                <p className="text-xl text-pink-100 mb-8 leading-relaxed">
                  Lassen Sie uns gemeinsam Ihre individuelle Finanzstrategie entwickeln. 
                  Für mehr Sicherheit und Selbstbestimmung in allen Lebensphasen.
                </p>
              <Link to="/contact">
                  <Button className="bg-white text-pink-600 hover:bg-gray-100 px-8 py-4 text-lg font-medium rounded-none shadow-lg border border-gray-200">
                    <span className="text-pink-600 font-bold">Persönliche Beratung vereinbaren</span>
                    <ArrowRight className="ml-2 w-5 h-5 text-pink-600" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
    </PublicShell>
  );
};

export default FinanzberatungFrauenPage;
